import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule } from '@angular/router';

import { NavItemActivePipe } from './nav-item-active.pipe';
import { NavLinkComponent } from './side-nav/nav-link/nav-link.component';
import { SideNavComponent } from './side-nav/side-nav.component';

@NgModule({
  imports: [CommonModule, RouterModule, MatExpansionModule],
  declarations: [NavItemActivePipe, SideNavComponent, NavLinkComponent],
  exports: [SideNavComponent, NavLinkComponent]
})
export class SharedNavigationModule {}
